import { render } from "./PollutionPerCrop.vue?vue&type=template&id=35513bb9"
import script from "./PollutionPerCrop.vue?vue&type=script&lang=js"
export * from "./PollutionPerCrop.vue?vue&type=script&lang=js"

import "./PollutionPerCrop.vue?vue&type=style&index=0&id=35513bb9&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__